import Glider from "glider-js";

// Make Glider available globally
window.Glider = Glider;
